<script>
import { enterpriseComputed } from '@state/helpers/enterprise'
import { Fragment } from 'vue-fragment'

export default {
  name: 'EnterpriseOriginToggle',
  components: {
    Fragment,
  },
  props: {
    origin: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...enterpriseComputed,
    currentEnterpriseOrigin() {
      return this.currentEnterprise
        ? this.currentEnterprise.originating_system
        : null
    },
  },
}
</script>
<template>
  <Fragment>
    <slot v-if="origin === currentEnterpriseOrigin"></slot>
    <slot v-else name="fallback"></slot>
  </Fragment>
</template>
